import { CodeTableEntry } from 'domain/components/codetable/CodeTableOptions';
import { useEffect } from 'react';
import useApi from './useApi';

type UseCodeTableConfig = {
  endpoint: string;
  avoidToken?: boolean;
  filter?: (o: CodeTableEntry) => boolean;
  includeEmpty?: boolean;
  emptyText?: string;
};

function useCodeTable(config: UseCodeTableConfig) {
  const [{ data: unfiltered }, request] = useApi<{ items: CodeTableEntry[] }>({
    url: '/codeTables' + config.endpoint,
    method: 'GET',
    bypassTokenCheck: config.avoidToken || false,
  });

  useEffect(() => {
    request();
  }, [request]);

  const { filter } = config;
  const filtered = filter
    ? unfiltered?.items.filter(filter)
    : unfiltered?.items;

  if (config.includeEmpty) {
    return [{ cd: '', descr: config.emptyText || '--' }, ...(filtered || [])];
  }
  return filtered || [];
}

export default useCodeTable;
